'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Conflit = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Conflit, _Component);

  function Conflit() {
    (0, _classCallCheck3.default)(this, Conflit);
    return (0, _possibleConstructorReturn3.default)(this, (Conflit.__proto__ || (0, _getPrototypeOf2.default)(Conflit)).apply(this, arguments));
  }

  (0, _createClass3.default)(Conflit, [{
    key: 'render',
    value: function render() {
      var styles = require(this.props.mobile ? './IntroMobile.scss' : './Intro.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.intro },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Quy tr\xECnh gi\u1EA3i quy\u1EBFt tranh ch\u1EA5p, khi\u1EBFu n\u1EA1i \u2013 Lookme.vn'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn v\xE0 \u0111\u1ED1i t\xE1c cung c\u1EA5p d\u1ECBch v\u1EE5 c\xF3 tr\xE1ch nhi\u1EC7m ti\u1EBFp nh\u1EADn v\xE0 x\u1EED l\xFD khi\u1EBFu n\u1EA1i c\u1EE7a Th\xE0nh vi\xEAn li\xEAn quan \u0111\u1EBFn giao d\u1ECBch t\u1EA1i website Lookme.vn .'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn c\xF3 quy\u1EC1n g\u1EEDi khi\u1EBFu n\u1EA1i v\u1EC1 vi\u1EC7c ch\u1EA5t l\u01B0\u1EE3ng d\u1ECBch v\u1EE5 kh\xF4ng \u0111\xFAng v\u1EDBi m\xF4 t\u1EA3, th\xF4ng tin thanh to\xE1n b\u1ECB ti\u1EBFt l\u1ED9 g\xE2y thi\u1EC7t h\u1EA1i cho m\xECnh \u0111\u1EBFn Ban qu\u1EA3n tr\u1ECB c\u1EE7a SGD TM\u0110T Lookme.vn . Khi ti\u1EBFp nh\u1EADn nh\u1EEFng ph\u1EA3n h\u1ED3i n\xE0y, Lookme.vn s\u1EBD x\xE1c nh\u1EADn l\u1EA1i th\xF4ng tin, tr\u01B0\u1EDDng h\u1EE3p \u0111\xFAng nh\u01B0 ph\u1EA3n \xE1nh c\u1EE7a Th\xE0nh vi\xEAn t\xF9y theo m\u1EE9c \u0111\u1ED9, Lookme.vn s\u1EBD c\xF3 nh\u1EEFng bi\u1EC7n ph\xE1p x\u1EED l\xFD k\u1ECBp th\u1EDDi.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'C\xE1c b\u01B0\u1EDBc gi\u1EA3i quy\u1EBFt tranh ch\u1EA5p, khi\u1EBFu n\u1EA1i:'
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 1: Ti\u1EBFp nh\u1EADn khi\u1EBFu n\u1EA1i'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Th\xE0nh vi\xEAn c\xF3 th\u1EC3 g\u1EEDi \xFD ki\u1EBFn \u0111\xF3ng g\xF3p ho\u1EB7c \u0111\u01A1n khi\u1EBFu n\u1EA1i b\u1EB1ng c\xE1c h\xECnh th\u1EE9c sau:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'G\u1EEDi th\u01B0 qua \u0111\u01B0\u1EDDng b\u01B0u \u0111i\u1EC7n v\u1EC1 \u0111\u1ECBa ch\u1EC9 tr\u1EE5 s\u1EDF ch\xEDnh c\u1EE7a Lookme.vn (Trong n\u1ED9i dung th\u01B0 ghi r\xF5 nh\u1EEFng v\u1EA5n \u0111\u1EC1 Th\xE0nh vi\xEAn c\u1EA7n khi\u1EBFu n\u1EA1i v\xE0 m\u1ED9t s\u1ED1 th\xF4ng tin t\xE0i li\u1EC7u li\xEAn quan \u0111\u1EC3 h\u1ED7 tr\u1EE3 cho vi\u1EC7c x\u1EED l\xFD v\xE0 gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i).'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Ng\u01B0\u1EDDi mua g\u1EEDi khi\u1EBFu n\u1EA1i t\u1EA1i \u0111\u1ECBa ch\u1EC9: '
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xF4ng ty C\u1ED5 Ph\u1EA7n Lookme'
        ),
        _react2.default.createElement(
          'p',
          null,
          'V\u0103n ph\xF2ng giao d\u1ECBch: 481/14 \u0110\u01B0\u1EDDng s\u1ED1 10, Ph\u01B0\u1EDDng 8, Qu\u1EADn G\xF2 V\u1EA5p, Th\xE0nh ph\u1ED1 H\u1ED3 Ch\xED Minh'
        ),
        _react2.default.createElement(
          'p',
          null,
          'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i: 0903 933 880 - Email: hr@lookme.vn '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 2: Ph\xE2n t\xEDch, \u0111\xE1nh gi\xE1'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Trong v\xF2ng 24 gi\u1EDD (kh\xF4ng k\u1EC3 ng\xE0y Th\u1EE9 b\u1EA3y, Ch\u1EE7 nh\u1EADt, L\u1EC5, T\u1EBFt) k\u1EC3 t\u1EEB ng\xE0y ti\u1EBFp nh\u1EADn \u0111\u01A1n khi\u1EBFu n\u1EA1i, Lookme.vn s\u1EBD ti\u1EBFn h\xE0nh \u0111i\u1EC1u tra, x\xE1c minh, ph\xE2n t\xEDch v\xE0 \u0111\xE1nh gi\xE1 \u0111\u01A1n khi\u1EBFu n\u1EA1i c\u1EE7a Th\xE0nh vi\xEAn b\u1EB1ng c\xE1ch x\xE1c th\u1EF1c l\u1EA1i th\xF4ng tin v\u1EDBi \u0111\u1ED1i t\xE1c v\u1EC1 tr\u01B0\u1EDDng h\u1EE3p \u0111\xF3 c\u0169ng nh\u01B0 n\u1EBFu th\u1EA5y t\xEDnh ch\u1EA5t nghi\xEAm tr\u1ECDng, ch\xFAng t\xF4i s\u1EBD y\xEAu c\u1EA7u c\xE1c b\xEAn cung c\u1EA5p them b\u1EB1ng ch\u1EE9ng, ch\u1EE9ng t\u1EEB ch\u1EE9ng minh cho v\u1EE5 vi\u1EC7c.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 3: T\u1ED5ng h\u1EE3p th\xF4ng tin v\xE0 gi\u1EA3i quy\u1EBFt khi\u1EBFu n\u1EA1i'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Sau khi x\xE1c minh r\xF5 v\u1EA5n \u0111\u1EC1 khi\u1EBFu n\u1EA1i, Lookme.vn s\u1EBD t\u1ED5ng h\u1EE3p th\xF4ng tin v\xE0 c\u0103n c\u1EE9 theo quy \u0111\u1ECBnh c\u1EE7a Lookme.vn \u0111\u1EC3 x\u1EED l\xFD v\xE0 gi\u1EA3i \u0111\xE1p khi\u1EBFu n\u1EA1i c\u1EE7a kh\xE1ch h\xE0ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 4: Tr\u1EA3 l\u1EDDi kh\xE1ch h\xE0ng'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Trong v\xF2ng 24 gi\u1EDD l\xE0m vi\u1EC7c k\u1EC3 t\u1EEB khi nh\u1EADn \u0111\u01B0\u1EE3c khi\u1EBFu n\u1EA1i, Lookme.vn s\u1EBD c\xF3 ph\u1EA3n h\u1ED3i cho Th\xE0nh vi\xEAn th\xF4ng qua nh\u1EEFng ph\u01B0\u01A1ng ti\u1EC7n kh\xE1c nh\u01B0 email, \u0111i\u1EC7n tho\u1EA1i. N\u1EBFu khi\u1EBFu n\u1EA1i c\xF3 t\xEDnh ch\u1EA5t ph\u1EE9c t\u1EA1p v\xE0 c\u1EA7n th\xEAm th\u1EDDi gian \u0111\u1EC3 gi\u1EA3i quy\u1EBFt v\xE0 tr\u1EA3 l\u1EDDi cho Th\xE0nh vi\xEAn m\u1ED9t c\xE1ch r\xF5 r\xE0ng, Lookme.vn s\u1EBD tr\u1EF1c ti\u1EBFp li\xEAn h\u1EC7 v\u1EDBi kh\xE1ch h\xE0ng \u0111\u1EC3 gia h\u1EA1n th\u1EDDi gian tr\u1EA3 l\u1EDDi.',
          ' '
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'i',
              null,
              'B\u01B0\u1EDBc 5: K\u1EBFt th\xFAc'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Lookme.vn t\xF4n tr\u1ECDng v\xE0 nghi\xEAm t\xFAc th\u1EF1c hi\u1EC7n c\xE1c quy \u0111\u1ECBnh c\u1EE7a ph\xE1p lu\u1EADt v\u1EC1 b\u1EA3o v\u1EC7 quy\u1EC1n l\u1EE3i c\u1EE7a ng\u01B0\u1EDDi mua (ng\u01B0\u1EDDi ti\xEAu d\xF9ng). V\xEC v\u1EADy, \u0111\u1EC1 ngh\u1ECB c\xE1c th\xE0nh vi\xEAn b\xE1n d\u1ECBch v\u1EE5 tr\xEAn s\xE0n cung c\u1EA5p \u0111\u1EA7y \u0111\u1EE7, ch\xEDnh x\xE1c, trung th\u1EF1c v\xE0 chi ti\u1EBFt c\xE1c th\xF4ng tin li\xEAn quan \u0111\u1EBFn d\u1ECBch v\u1EE5. M\u1ECDi h\xE0nh vi l\u1EEBa \u0111\u1EA3o, gian l\u1EADn trong kinh doanh \u0111\u1EC1u b\u1ECB l\xEAn \xE1n v\xE0 ph\u1EA3i ch\u1ECBu ho\xE0n to\xE0n tr\xE1ch nhi\u1EC7m tr\u01B0\u1EDBc ph\xE1p lu\u1EADt.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'C\xE1c Lookme.vnao g\u1ED3m ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5, ng\u01B0\u1EDDi mua s\u1EBD ph\u1EA3i c\xF3 vai tr\xF2 tr\xE1ch nhi\u1EC7m trong vi\u1EC7c t\xEDch c\u1EF1c gi\u1EA3i quy\u1EBFt v\u1EA5n \u0111\u1EC1. \u0110\u1ED1i v\u1EDBi ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 c\u1EA7n c\xF3 tr\xE1ch nhi\u1EC7m cung c\u1EA5p v\u0103n b\u1EA3n gi\u1EA5y t\u1EDD ch\u1EE9ng th\u1EF1c th\xF4ng tin li\xEAn quan \u0111\u1EBFn s\u1EF1 vi\u1EC7c \u0111ang g\xE2y m\xE2u thu\u1EABn cho kh\xE1ch h\xE0ng. \u0110\u1ED1i v\u1EDBi Lookme.vn s\u1EBD c\xF3 tr\xE1ch cung c\u1EA5p nh\u1EEFng th\xF4ng tin li\xEAn quan \u0111\u1EBFn ng\u01B0\u1EDDi mua v\xE0 ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 n\u1EBFu \u0111\u01B0\u1EE3c ng\u01B0\u1EDDi mua ho\u1EB7c ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 (li\xEAn quan \u0111\u1EBFn tranh ch\u1EA5p \u0111\xF3) y\xEAu c\u1EA7u.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Sau khi ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5, ng\u01B0\u1EDDi mua \u0111\xE3 gi\u1EA3i quy\u1EBFt xong tranh ch\u1EA5p ph\u1EA3i c\xF3 tr\xE1ch nhi\u1EC7m b\xE1o l\u1EA1i cho ban qu\u1EA3n tr\u1ECB Lookme.vn . Trong tr\u01B0\u1EDDng h\u1EE3p giao d\u1ECBch ph\xE1t sinh m\xE2u thu\u1EABn m\xE0 l\u1ED7i thu\u1ED9c v\u1EC1 ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5: Lookme.vn s\u1EBD c\xF3 bi\u1EC7n ph\xE1p c\u1EA3nh c\xE1o, kh\xF3a t\xE0i kho\u1EA3n ho\u1EB7c chuy\u1EC3n cho c\u01A1 quan ph\xE1p lu\u1EADt c\xF3 th\u1EA9m quy\u1EC1n t\xF9y theo m\u1EE9c \u0111\u1ED9 c\u1EE7a sai ph\u1EA1m. Lookme.vn s\u1EBD ch\u1EA5m d\u1EE9t v\xE0 g\u1EE1 b\u1ECF to\xE0n b\u1ED9 tin b\xE0i v\u1EC1 d\u1ECBch v\u1EE5 c\u1EE7a ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 \u0111\xF3 tr\xEAn Lookme.vn \u0111\u1ED3ng th\u1EDDi y\xEAu c\u1EA7u ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 b\u1ED3i ho\xE0n cho kh\xE1ch h\xE0ng th\u1ECFa \u0111\xE1ng tr\xEAn c\u01A1 s\u1EDF th\u1ECFa thu\u1EADn v\u1EDBi kh\xE1ch h\xE0ng.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'N\u1EBFu th\xF4ng qua h\xECnh th\u1EE9c th\u1ECFa thu\u1EADn m\xE0 v\u1EABn kh\xF4ng th\u1EC3 gi\u1EA3i quy\u1EBFt \u0111\u01B0\u1EE3c m\xE2u thu\u1EABn ph\xE1t sinh t\u1EEB giao d\u1ECBch gi\u1EEFa 2 b\xEAn ng\u01B0\u1EDDi mua, ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5, th\xEC m\u1ED9t trong 2 b\xEAn ng\u01B0\u1EDDi mua v\xE0 ng\u01B0\u1EDDi cung c\u1EA5p d\u1ECBch v\u1EE5 s\u1EBD c\xF3 quy\u1EC1n nh\u1EDD \u0111\u1EBFn c\u01A1 quan ph\xE1p lu\u1EADt c\xF3 th\u1EA9m quy\u1EC1n can thi\u1EC7p nh\u1EB1m \u0111\u1EA3m b\u1EA3o l\u1EE3i \xEDch h\u1EE3p ph\xE1p c\u1EE7a c\xE1c b\xEAn nh\u1EA5t l\xE0 cho kh\xE1ch h\xE0ng.'
        )
      );
    }
  }]);
  return Conflit;
}(_react.Component), _class.propTypes = {
  customTitleStyle: _react.PropTypes.any,
  customStyle: _react.PropTypes.any,
  mobile: _react.PropTypes.bool
}, _temp);
exports.default = Conflit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Policy/Conflit.js
// module id = 1650
// module chunks = 0